import {Dispatch} from 'redux';

import API from '../../api/axios';
import {apiBaseUrl} from '../../api/urls';
import {ConfigurationResponse} from '../../interfaces/Configuration';
import {MeResponse} from '../../interfaces/Me';
import {getAppInitialState} from './reducers';
import {AppState} from './types';

export enum Actions {
  SetApp = 'SetApp',
}

const appActions = {
  setApp: (dispatch: Dispatch, data: Partial<AppState>) => {
    return dispatch({type: Actions.SetApp, data});
  },

  fetchMe: async (dispatch: Dispatch) => {
    const me = (await API.get<MeResponse>(`${apiBaseUrl}/user/me`)).data;
    return appActions.setApp(dispatch, {me});
  },

  fetchMyConfigurations: async (dispatch: Dispatch) => {
    const myConfigurations = (
      await API.get<ConfigurationResponse>(`${apiBaseUrl}/user-configuration`)
    ).data;
    return appActions.setApp(dispatch, {myConfigurations});
  },

  setMuteSounds: async (dispatch: Dispatch, muteSounds: boolean) => {
    return appActions.setApp(dispatch, {muteSounds});
  },

  clearApp: (dispatch: Dispatch) => {
    const data: AppState = {
      ...getAppInitialState(),
      companyId: null,
    };

    return dispatch({type: Actions.SetApp, data});
  },
};

export default appActions;
